
















































































































































import Vue from 'vue';
import moment from 'moment';
import ReservationCard from '@/components/Reservations/ReservationCard.vue';
import {
  LocationEntity,
  EntranceEntity,
  TimeslotEntity,
  ManualGroupEntity,
  ReservationEntity,
  GetExternalUserReservationsOptions,
} from '../../../types';
import { getLowestUtilizedEntrance, logError } from '../helpers';

export default Vue.extend({
  name: 'manage-reservations',
  components: {
    ReservationCard,
  },
  props: {
    pathExternalUserId: {
      type: String,
      required: true,
    },
  },
  async created() {
    (this as any).startLoading();

    (this as any).updateQueryParameters();

    this.$store.commit('appData/REMOVE_EXISTING_DATA');

    const options: GetExternalUserReservationsOptions = {
      externalUserId: this.pathExternalUserId,
      customerId: (this as any).customerId,
    };

    await this.$store.dispatch('appData/GET_EXTERNAL_USER_RESERVATIONS', options);

    const externalUserReservationsWithVisualSettings = (this as any).externalUserReservations.find(
      (externalUserReservation: ReservationEntity) =>
        (externalUserReservation.location && externalUserReservation.location.visualSettings) ||
        (externalUserReservation.locations && externalUserReservation.locations.find((location) => location.visualSettings)),
    );

    const externalUserReservationsWithTranslations = (this as any).externalUserReservations.find(
      (externalUserReservation: ReservationEntity) =>
        (externalUserReservation.location && externalUserReservation.location.translations) ||
        (externalUserReservation.locations && externalUserReservation.locations.find((location) => location.translations)),
    );

    const externalUserReservationsLocationVisualSettings =
      externalUserReservationsWithVisualSettings && externalUserReservationsWithVisualSettings.locations
        ? externalUserReservationsWithVisualSettings.locations.find((location: LocationEntity) => location.visualSettings).visualSettings
        : externalUserReservationsWithVisualSettings
        ? externalUserReservationsWithVisualSettings.location.visualSettings
        : null;

    const externalUserReservationsLocationTranslations =
      externalUserReservationsWithTranslations && externalUserReservationsWithTranslations.locations
        ? externalUserReservationsWithTranslations.locations.find((location: LocationEntity) => location.translations).translations
        : externalUserReservationsWithTranslations
        ? externalUserReservationsWithTranslations.location.translations
        : null;

    (this as any).setVisualSettings(externalUserReservationsLocationVisualSettings);

    (this as any).setTranslations(externalUserReservationsLocationTranslations);

    (this as any).stopLoading();
  },
  methods: {
    newReservation(): void {
      this.$router.push({
        name: 'reserve',
        query: {
          apiKey: (this as any).apiKey || (this as any).externalUserAPIKeyUsed,
          customerId: (this as any).customerId,
          ...((this as any).locationId && { locationId: (this as any).locationId }),
          occupantTypeId: (this as any).occupantTypeId,
          lang: this.$root.$i18n.locale,
          webview: (this as any).webview,
          externalUserId: this.pathExternalUserId,
          primaryColor: (this as any).primaryColor.replace('#', ''),
          primaryFontColor: (this as any).primaryFontColor.replace('#', ''),
          primaryButtonFontColor: (this as any).primaryButtonFontColor.replace('#', ''),
          secondColor: (this as any).secondColor.replace('#', ''),
          secondFontColor: (this as any).secondFontColor.replace('#', ''),
          secondButtonFontColor: (this as any).secondButtonFontColor.replace('#', ''),
          thirdColor: (this as any).thirdColor.replace('#', ''),
          thirdFontColor: (this as any).thirdFontColor.replace('#', ''),
          thirdButtonFontColor: (this as any).thirdButtonFontColor.replace('#', ''),
          fourthColor: (this as any).fourthColor.replace('#', ''),
          fourthFontColor: (this as any).fourthFontColor.replace('#', ''),
          fourthButtonFontColor: (this as any).fourthButtonFontColor.replace('#', ''),
          headerBackgroundColor: (this as any).headerBackgroundColor.replace('#', ''),
          languagePickerColor: (this as any).languagePickerColor.replace('#', ''),
          ...((this as any).widgetLayout && {
            widgetLayout: (this as any).widgetLayout,
          }),
          ...((this as any).cssURL && { cssURL: (this as any).cssURL }),
          ...((this as any).visitTypeId && { visitTypeId: (this as any).visitTypeId }),
          ...((this as any).fcmToken && { fcmToken: (this as any).fcmToken }),
          ...((this as any).queryParametersName && { name: (this as any).queryParametersName }),
          ...((this as any).queryParametersEmail && { email: (this as any).queryParametersEmail }),
        },
      });
    },
  },
  computed: {
    filteredReservations(): ReservationEntity[] {
      return (this as any).externalUserReservations.filter((externalUserReservation: ReservationEntity) => {
        return !externalUserReservation.manualGroup && externalUserReservation.timeslot
          ? moment().isBefore(
              moment(`${moment(externalUserReservation.startDate).format('YYYY-MM-DD')}T${externalUserReservation.timeslot.startTime}`),
            )
          : externalUserReservation.manualGroup && externalUserReservation.manualGroup.expirationDate
          ? moment().isBefore(moment(`${externalUserReservation.manualGroup.expirationDate}T00:00:01`))
          : true;
      });
    },
    regularReservations(): ReservationEntity[] {
      return this.filteredReservations.filter((reservation) => reservation.type === 1);
    },
    manualGroupReservations(): ReservationEntity[] {
      return this.filteredReservations.filter((reservation) => reservation.type === 2);
    },
  },
});
